const doc = [({"da":({"js":({"nemoa":({"required_metadata":({"required_metadata_proxy":({"fill_out_missing_fields_to_continue":"Udfyld manglende felter for at fortsætte."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;